import React from "react";
import { useParams, Link } from "react-router-dom";
import solutionData from "../Data/solutionData";
import "../style/Solution.css";

const SolutionList = () => {
  const { category } = useParams(); 
  const data = solutionData[category]; 

  if (!data) {
    return <h2>⚠ Solution not found</h2>;
  }

  return (
    <div className="solution-list">
      <h1>{category.toUpperCase()} SHADING SOLUTIONS</h1>
      <div className="solution-grid">
        {data.map((item) => (
          <div key={item.id} className="solution-card">
            <img src={item.img} alt={item.title} />            
            <div className="solution-card-content">
              <Link to={`/solution/${category}/${item.id}`} style={{textDecoration: "none"}} >
              <h3>{item.name}</h3>
              <p>{item.desc}</p>
                
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SolutionList;
